import React, { useState } from 'react';
import styles from './index.module.scss';
import { getImageFromS3 } from '../../../../imageService';

const ResultComponent = ({
  setScreenNumber,
  otpStatus,
  handleBackAfterSendReview
}) => {
  console.log(handleBackAfterSendReview);
  const isSuccess = otpStatus === 'PENDING_OTP';
  const [showMainHeart, setShowMainHeart] = useState(true);
  const [showHeartExplosion, setShowHeartExplosion] = useState(false);

  const handleHeartClick = () => {
    setShowMainHeart(false);
    setShowHeartExplosion(true);

    setTimeout(() => {
      setShowHeartExplosion(false);

      setTimeout(() => {
        setShowMainHeart(true);
      }, 100);
    }, 1500);
  };

  const smallHeartSizes = [21, 23, 56, 54, 39, 43, 33, 43, 37, 39, 42, 35];

  return (
    <div
      className={styles.container}
      style={{
        backgroundImage: `url("${getImageFromS3(
          'images/review-screen/violet-background.png'
        )}")`
      }}
    >
      <div className={styles.content}>
        <p className={styles.title}>Дякуємо за відгук!</p>
        <p className={styles.subtitle}>
          {isSuccess
            ? 'Твій мобільний рахунок буде поповнено найближчим часом.'
            : 'Для отримання поповнення приходь наступного місяця!'}
        </p>
        <div className={styles.hearContainer}>
          {showMainHeart && (
            <img
              src={getImageFromS3('images/review-screen/heart.png')}
              alt="Heart"
              className={styles.mainHeart}
              onClick={handleHeartClick}
            />
          )}
          {showHeartExplosion && (
            <div className={styles.heartExplosion}>
              {[...Array(12)].map((_, index) => (
                <img
                  key={index}
                  src={getImageFromS3('images/review-screen/small-heart.png')}
                  alt="Small Heart"
                  className={`${styles.smallHeart} ${
                    styles[`heart${index + 1}`]
                  }`}
                  style={{
                    width: `${smallHeartSizes[index]}px`,
                    height: 'auto'
                  }}
                />
              ))}
            </div>
          )}
        </div>
        {handleBackAfterSendReview && (
          <button
            className={styles.backButton}
            onClick={handleBackAfterSendReview}
          >
            Повернутись до меню
          </button>
        )}
      </div>
    </div>
  );
};

export default ResultComponent;
